import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

import '../../styles/Footer.scss';
import '../../styles/global.scss';
import contact from 'src/constants/contact';
import { colors } from 'src/styles/theme';

const Footer = () => {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));

  const textAlign = isMatch ? 'center' : 'left';
  return (
    <footer
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        left: 0,
        bottom: 0,
        right: 0,
        color: 'white',
        backgroundColor: colors.primary.main,
        marginTop: 'auto',
        width: '100%',
      }}
    >
      <Grid sx={{ maxWidth: '1000px', marginY: '1rem', marginX: '1rem' }} spacing={2} container>
        <Grid
          container
          item
          xs={12}
          md={6}
          lg={3}
          direction="column"
          justifyContent="flex-start"
          alignItems={textAlign}
          className="grid-container"
        >
          <Grid item sx={{ marginBottom: '8px' }}>
            <Typography variant="body2">Located at: </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              {contact.contactName}, {contact.title}
              <br /> {contact.street}
              <br /> {contact.room}
              <br /> {contact.city}, {contact.state} {contact.zip}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          lg={3}
          direction="column"
          justifyContent="flex-start"
          alignItems={textAlign}
          className="grid-container"
        >
          <Grid item sx={{ marginBottom: '8px' }}>
            <Typography variant="body2">Phone: </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              <a href={`tel:${contact.phone}`}>{contact.phone}</a>
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          lg={3}
          direction="column"
          justifyContent="flex-start"
          alignItems={textAlign}
          className="grid-container"
        >
          <Grid item sx={{ marginBottom: '8px' }}>
            <Typography variant="body2">Email: </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          lg={3}
          direction="column"
          justifyContent="flex-start"
          alignItems={textAlign}
          className="grid-container"
        >
          <Grid item sx={{ marginBottom: '8px' }}>
            <Typography variant="body2">Hours: </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">{contact.hours}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
